import React, { useState } from 'react';
import { faTimes, faSave, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';
import { ConfirmDialog } from '../../../../components/confirm-dialog/confirm-dialog';

interface ICitizenLessonDeviationLaunchboxProps {
  onSave: () => void;
  onValidate: () => boolean;
  onDelete: () => void;
  isSaving: boolean;
  isEditMode: boolean;
  isReadOnly: boolean;
  deviationsToDeleteCount: number;
}

export function CitizenLessonDeviationLaunchbox(props: ICitizenLessonDeviationLaunchboxProps) {
  const { isSaving, onSave, onValidate, onDelete, isEditMode, isReadOnly, deviationsToDeleteCount } = props;
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const deleteDialogMessage =
    deviationsToDeleteCount > 1 ? `Ønsker du at slette særplanen for de ${deviationsToDeleteCount} valgte lektioner?` : 'Ønsker du at slette den aktuelle særplan?';

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  function closeDeleteDialog() {
    setShowDeleteDialog(false);
  }

  function handleConfirmDelete() {
    closeDeleteDialog();
    onDelete();
  }

  return (
    <>
      <FloatingActionButtonBar>
        {isEditMode && !isReadOnly && (
          <>
            <FloatingActionButton buttonText="Slet særplan" icon={faTrashCan} onClick={() => setShowDeleteDialog(true)} />
            <FabDivider />
            <FloatingActionButton buttonText="Gem og luk" icon={faSave} onClick={handleSave} inverted loading={isSaving} />
          </>
        )}
        <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
      </FloatingActionButtonBar>
      <ConfirmDialog
        title="Slet særplan"
        message={deleteDialogMessage}
        open={showDeleteDialog}
        type="question"
        isLoading={isSaving}
        onConfirmClick={handleConfirmDelete}
        onCancelClick={closeDeleteDialog}
        confirmButtonText="Slet"
        cancelButtonText="Annuller"
        cancelIsPrimary
        onClose={closeDeleteDialog}
      />
    </>
  );
}
